import React from "react";
import CourbesStatChart from "./CourbesStatChart.jsx";

/**
 * Besoin en eau cumulé : cumul de chaque statistique du besoin en eau
 * journalier (data.eau), via CourbesStatChart.
 * Statistiques proposées : Moyen, Quantile 75 et Quantile 90 (pas de Maximum).
 * Coché à l'ouverture : Moyen. Tableau : Moyen seulement.
 */
export default function EauCumuleeChart({ data, xMax }) {
  return (
    <CourbesStatChart
      data={data}
      prefixe="besoin"
      cleDate="date_affichage"
      unite="mm"
      nomAxe="mm"
      statsParDefaut={["moy"]}
      statsDisponibles={["moy", "q75", "q90"]}
      statsTableau={["moy"]}
      cumul
      xMax={xMax}
    />
  );
}
